<template>
  <DataEditor
    :uimodel="weekdaysUiModel"
    :show-label="false"
    ext-view-mode="edit"
    class="weekdays-editor"
    @restore="$emit('restore')"
    @input="updateWeekdays"
  />
</template>

<script>
export default {
  components: {
    DataEditor: () => import("../../DataEditor.vue"),
  },

  props: {
    uimodel: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getArrayFromWeekDaysString(weekdaysString) {
      if (weekdaysString === undefined || weekdaysString === null) {
        return weekdaysString;
      }
      const array = this.$cloneObject(weekdaysString)
        ?.split?.(",")
        ?.reduce?.((array, weekdayPart) => {
          if (weekdayPart.includes("-")) {
            const weekdayRange = weekdayPart.split("-");
            const startIdx = this.allWeekdays.findIndex(
              (day) => day === weekdayRange[0]
            );
            const endIdx = this.allWeekdays.findIndex(
              (day) => day === weekdayRange[1]
            );
            if (startIdx === -1 || endIdx === -1) return array;

            if (startIdx < endIdx) {
              const weekdays = this.allWeekdays.slice(startIdx, endIdx + 1);
              return array.concat(weekdays);
            }

            if (startIdx >= endIdx) {
              const fromStart = this.allWeekdays.slice(startIdx);
              const toEnd = this.allWeekdays.slice(0, endIdx + 1);
              const weekdays = fromStart.concat(toEnd);
              return array.concat(weekdays);
            }
          }

          if (weekdayPart === "*") {
            return array.concat(this.allWeekdays);
          }
          array.push(weekdayPart);
          return array;
        }, []);

      const set = new Set(array);
      return Array.from(set);
    },

    updateWeekdays(weekdayArray) {
      const weekdays = weekdayArray
        .filter((weekday) => weekday !== "")
        .join(",");
      this.$emit("input", weekdays);
    },
  },

  computed: {
    allWeekdays() {
      return ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
    },

    weekdaysUiModel() {
      const schema = {
        type: "array",
        items: {
          type: "string",
          enum: this.allWeekdays,
        },
        description: this.uimodel.schema.description,
        title: this.uimodel.schema.title,
      };

      const data = this.getArrayFromWeekDaysString(this.uimodel.data);
      const savedData = this.getArrayFromWeekDaysString(this.uimodel.savedData);
      const inheritedData = this.getArrayFromWeekDaysString(
        this.uimodel.inheritedData
      );

      const uimodel = {
        ...this.uimodel,
        data,
        savedData,
        inheritedData,
        schema,
      };

      return uimodel;
    },
  },
};
</script>

<style scoped>
.weekdays-editor.data-editor.array.has-enum-items.no-label::v-deep
  > .container {
  padding-top: 4px;
}
</style>